import type { IconType } from "react-icons";
import InputMask, { Props as InputMaskProps } from "react-input-mask";

import styles from "./styles.module.css";

interface Props extends Omit<InputMaskProps, "mask"> {
  icon: IconType;
  mask?: InputMaskProps["mask"];
  label?: string;
  id?: string;
}

export const Input = ({
  icon: Icon,
  label,
  id,
  ...props
}: Props): JSX.Element => (
  <div className={styles.container}>
    {label && <h3 className={styles.label}>{label}</h3>}
    <div className={styles.inputWrapper}>
      <InputMask
        id={id}
        {...(props as InputMaskProps)}
        className={styles.input}
      />
      <Icon size="25px" color="#bbbbbb" />
    </div>
  </div>
);
